var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkipNextIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.00286V17.0029M6.972 5.26986C6.88355 5.19997 6.77719 5.15641 6.66513 5.14417C6.55306 5.13193 6.43981 5.15152 6.33836 5.20068C6.23691 5.24984 6.15136 5.32658 6.09152 5.42212C6.03167 5.51766 5.99996 5.62813 6 5.74086V18.2649C6.00014 18.3775 6.032 18.4878 6.09191 18.5832C6.15183 18.6786 6.23739 18.7552 6.33881 18.8043C6.44022 18.8533 6.5534 18.8728 6.66537 18.8605C6.77735 18.8483 6.88362 18.8047 6.972 18.7349L14.903 12.4739C14.9742 12.4177 15.0317 12.3461 15.0712 12.2646C15.1108 12.183 15.1313 12.0935 15.1313 12.0029C15.1313 11.9122 15.1108 11.8227 15.0712 11.7412C15.0317 11.6596 14.9742 11.588 14.903 11.5319L6.972 5.26986Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipNextIcon);
export default __webpack_public_path__ + "static/media/skip-next-icon.ad9fb0e604477d3680a47b74fce0855a.svg";
export { ForwardRef as ReactComponent };